// * Toggle the scroll-to-top FAB once the page has scrolled past the toolbar
// * and scroll back to the top (toolbar) when it's clicked.
(() => {
  const SCROLL_THRESHOLD = 80;

  document.addEventListener('DOMContentLoaded', () => {
    const button = document.querySelector('[data-page-fab-scrolltop]');
    if (!button) {
      return;
    }

    const toggleVisibility = () => {
      button.classList.toggle('is-visible', window.scrollY > SCROLL_THRESHOLD);
    };

    window.addEventListener('scroll', toggleVisibility, { passive: true });
    toggleVisibility();

    button.addEventListener('click', () => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  });
})();
